module.exports = __webpack_public_path__ + "img/1478933577.1546ca2a.jpg";